import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectSiteLayoutType } from '../../../../../common/redux/features/siteConfig/selectors';
import { API_TYPES } from '../../../ApiDisplay';
import { PermissionsNote } from '../PermissionsNote';
import { RequestAuthorization } from '../RequestAuthorization';

interface AuthorizationAndPermissionsProps {
  permissions: any[];
  isSpiDocs?: boolean;
  isEvent?: boolean;
}

export const AuthorizationAndPermissions = ({
  permissions,
  isSpiDocs,
  isEvent,
}: AuthorizationAndPermissionsProps) => {
  const layoutType = useSelector(selectSiteLayoutType);

  const shouldRenderPermissions = () => {
    return (
      !!(permissions && Array.isArray(permissions) && permissions.length) &&
      !(isEvent && layoutType === API_TYPES.RPC)
    );
  };

  const shouldRenderAuthorization = () => !isSpiDocs && !isEvent;

  return (
    <React.Fragment>
      {shouldRenderAuthorization() && <RequestAuthorization />}
      {shouldRenderPermissions() && (
        <PermissionsNote permissions={permissions} isEvent={isEvent} />
      )}
    </React.Fragment>
  );
};
